import { motion } from "framer-motion";
import { EASE } from "./Motion";

export const FeatureCard = ({ index, title, desc, icon: Icon, className = "", children, delay = 0 }) => (
  <motion.article
    data-testid={`feature-card-${title.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-$/, "")}`}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={`group relative flex flex-col overflow-hidden rounded-card border border-white/10 bg-pa-surface p-6 transition-[border-color,transform,box-shadow] duration-500 ease-out-expo hover:-translate-y-1 hover:border-pa-orange/50 hover:shadow-glow lg:p-8 ${className}`}
  >
    <div className="flex items-start justify-between">
      <span className="grid h-11 w-11 place-items-center border border-white/15 text-pa-ink transition-colors duration-500 group-hover:border-pa-orange group-hover:bg-pa-orange group-hover:text-pa-black group-hover:shadow-[0_0_28px_rgba(242,101,49,0.7)]">
        <Icon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" />
      </span>
      <span className="font-mono text-xs text-pa-dim">{String(index).padStart(2, "0")}</span>
    </div>
    {children && <div className="mt-8 flex-1">{children}</div>}
    <div className={children ? "mt-8" : "mt-auto pt-12"}>
      <h3 className="font-display text-3xl uppercase leading-none text-pa-ink lg:text-[2.1rem]">{title}</h3>
      <p className="mt-3 max-w-md text-[15px] leading-relaxed text-pa-muted">{desc}</p>
    </div>
  </motion.article>
);
